// allowed keys for numeric only inputs
export const ALLOWED_NUMERIC_EXTRA_CHARACTERS = ['Tab', 'Backspace', 'Enter', '0', 'ArrowUp', 'ArrowDown']
